import { IsIn, IsArray, ArrayMinSize, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { BaseTaskDto } from './base-task.dto';
import { NodeActionDto } from './node-action.dto';

const MIN_SIZE = 2;

export class BranchTaskDto extends BaseTaskDto {
  @IsIn(['BranchTask'])
  type: 'BranchTask';

  @IsArray()
  @ArrayMinSize(MIN_SIZE, { message: 'Обязательное поле' })
  @ValidateNested({ each: true })
  @Type(() => NodeActionDto)
  actions: NodeActionDto[];
}
